var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlueIllustrationBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 456,
    height: 478,
    viewBox: "0 0 456 478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Mission-result-bottom"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 456,
    height: 478
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mission-result-bottom",
    clipPath: "url(#clip-Mission-result-bottom)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(16.04 -562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M-793.3,266.9C-894.619,204.123-919.5,7.476-919.281-83L-1170.04,842.775,238.512,1608.53l466.1-335.27c-37.6-59.5-171.439-193.5-405.972-253.49C5.477,944.774,166.012,718.854-67.966,498.7S-666.641,345.37-793.3,266.9Z",
    fill: "#164273"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueIllustrationBottom);
export default __webpack_public_path__ + "static/media/blue-illustration-bottom.9af304e2fd76e93f581e039b3ff8e18d.svg";
export { ForwardRef as ReactComponent };